import {getCatalogBtn} from "./helper/helpers";

const NotLoggedButton = (props) => {
    let defaultText = props.type === "subscription" ? gettext("Subscribe") : gettext("Add to cart");
    const productButton = getCatalogBtn();
    return (
        <button onClick={() => selectCountryAnonymous()} className={productButton}>{defaultText} </button>
    )
};

export default NotLoggedButton;
